<template>
  <div class="bp-export-button">
    <bp-export-button-popper trigger="clickToToggle" :options="popperOptions">
      <div slot="reference" ref="referenceSlot">
        <slot>
          <bp-button
            icon="fa-regular fa-download"
            class="w-100"
            :size="size"
            :color="color"
            :variant="variant"
            :loading="loading"
            :divider="!square"
            :disabled="isDisabled"
            :label="square ? '' : label"
            :trailing-icon="square ? '' : 'fa-regular fa-angle-down'"
          />
        </slot>
      </div>

      <div slot="default" class="bp-export-button-options-dropdown">
        <bp-button
          v-for="opt in exportOptions"
          size="md"
          color="neutral"
          variant="glyph"
          class="bp-export-button-option"
          :key="opt.id"
          :icon="opt.icon"
          :label="opt.label"
          @click="selectOption(opt)"
        />
      </div>
    </bp-export-button-popper>
  </div>
</template>
<script>
var a = document.createElement("a");

import { clearObject } from "@/functions/helpers";
import moment from "moment";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
export default {
  components: { "bp-export-button-popper": Popper },
  props: {
    action: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filename: {
      type: String,
      default: "blitzpay_export_data"
    },
    size: {
      type: String,
      default: "md"
    },
    variant: {
      type: String,
      default: "filled-1"
    },
    color: {
      type: String,
      default: "neutral"
    },
    label: {
      type: String,
      default: "Exportar"
    },
    square: {
      type: Boolean,
      default: false
    },
    filters: {
      type: [Object, Function],
      default: () => ({})
    },
    confirmation: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      exportOptions: [
        {
          id: "csv",
          icon: "fa-regular fa-file-csv",
          label: "Arquivo compacto em CSV"
        },
        {
          id: "excel",
          icon: "fa-regular fa-table",
          label: "Arquivo compacto em Excel"
        }
      ],
      format: "csv"
    };
  },
  computed: {
    popperOptions() {
      return {
        placement: "auto",
        modifiers: {
          offset: {
            offset: "0,4px"
          }
        }
      };
    },
    isDisabled() {
      return this.disabled || this.loading;
    }
  },
  methods: {
    selectOption(option) {
      this.$refs.referenceSlot.click();
      this.format = option.id;

      if (this.confirmation) this.$emit("select", option.id);
      else this.exportData();
    },
    generateLink(data) {
      let href;
      if (this.format === "excel") {
        var binaryData = [];
        binaryData.push(data);
        href = URL.createObjectURL(
          new Blob(binaryData, {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          })
        );
      } else {
        href = `data:text/csv;charset=utf-8,${data.replaceAll("#", "%23")}`;
      }
      a.href = href;

      const format = this.format === "excel" ? "xlsx" : "csv";

      a.setAttribute(
        "download",
        `${this.filename}_${moment().format(
          "YYYYMMDD"
        )}_${moment().unix()}.${format}`
      );
    },
    async exportData(filters = this.filters) {
      this.loading = true;

      if (typeof filters == "function") filters = filters();
      const params = {
        export: true,
        export_format: this.format,
        ...filters
      };

      try {
        const { data } = await this.$store.dispatch(
          this.action,
          clearObject(params)
        );
        this.generateLink(data);
        a.click();
      } catch (e) {
        this.$message.error("Erro ao exportar dados");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-export-button {
  .bp-export-button-options-dropdown {
    padding: 8px;
    z-index: 100;
    overflow: scroll;
    max-height: 400px;
    border-radius: 4px;
    border: 1px solid rgba(215, 215, 215, 0.48);
    background: rgba(255, 255, 255, 0.64);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
    backdrop-filter: blur(12px);

    gap: 4px;
    display: flex;
    flex-direction: column;
  }
}
</style>
